module.exports = __webpack_public_path__ + "img/fabulous.532e48f2.svg";